import React,{useEffect,useState} from 'react';
import { Routes, Route,useLocation } from 'react-router-dom';

import Header from "@src/common/Header";
import Footer from "@src/common/Footer";

import PrivateRoute from './PrivateRoute';

import Login from '../view/auth/Login.js';
import RoleList from '../role/RoleList'
import LeadList from '@src/lead/LeadList';
import ReconciliationtList from '@src/Reconciliation/ReconciliationList';
import ReconciliationDetail from '@src/Reconciliation/ReconciliationDetail';
import LeadDetail from '../../src/lead/LeadDetail';
import RuleEngine from '@src/component/rule-engine/RuleEngine';
import PaymentList from '@src/paymentverfication/PaymentList';
import RemittanceList from '@src/remittance/RemittanceList';
import RemittanceDetail from '@src/remittance/detail/RemittanceDetail';
import { COUNTRY_CODE, APP_COUNTRY } from '../config/constant';
import { getPublicKey } from '../store/slices/encryption';
import Bank from '@src/config-panel/Bank';


const AppRouter = () => {
    const location = useLocation()
    let currentPath = location.pathname;
    // const loadRoutes=true;
    const [loadRoutes, setLoadRoutes] = useState(true)

    useEffect(()=>{
        getPublicKey().then((res: any)=> {
            if(res?.data) setLoadRoutes(true)
        })
        // eslint-disable-next-line
    },[])
    
    return (
        <>
            {
                !["/", "", "/login", "/delete/account" ,"/not-found"].includes(currentPath) && <Header />
            }
            { loadRoutes && <Routes>

                <Route path="/" element={<PrivateRoute components={Login} accessPageId="23"  accessType = "isVisible"/>} />  
                <Route path="/login" element={<PrivateRoute components={Login} accessPageId="23"  accessType = "isVisible"/>} /> 

                {/* <Route path="/lead-detail" element={<PrivateRoute components={LeadDetail} accessPageId="23"  accessType = "isVisible"/>} />        */}
                {/* <Route path="/role-list" element={<PrivateRoute components={RoleList}  accessType="isVisible" />} /> */}
                <Route path="/role-list" element={<PrivateRoute components={RoleList} accessPageId="24"  accessType = "isVisible"/>} />
                <Route path="/lead-list" element={<PrivateRoute components={LeadList} accessPageId="25"  accessType = "isVisible"/>}/>         
                {
                    COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH && (
                        <>
                            <Route path="/reconciliation-list" element={<PrivateRoute components={ReconciliationtList} accessPageId="26"  accessType = "isVisible"/>} /> 
                            <Route path="/details/reconciliation-detail/:id" element={<PrivateRoute components={ReconciliationDetail} accessPageId="27"  accessType = "isVisible"/>} /> 
                            <Route path="/payment-list" element={<PrivateRoute components={PaymentList} accessPageId="28"  accessType = "isVisible"/>} /> 
                        </>
                    )
                }
                {
                    COUNTRY_CODE === APP_COUNTRY.APP_TYPE_ID && (
                        <>
                            <Route path="/config" element={<PrivateRoute components={Bank} accessPageId="23"  accessType = "isVisible" />} />
                        </>
                    )
                }
                <Route path="/lead-details/:id" element={<PrivateRoute components={LeadDetail} accessPageId="29"  accessType = "isVisible"/>} />  
                <Route path="/rule-engine" element={<PrivateRoute components={RuleEngine} accessPageId="21" accessType="isVisible" />} />
                <Route path="/remittance-list" element={<PrivateRoute components={RemittanceList} accessPageId="23"  accessType = "isVisible"/>} />
                <Route path="/remittance-details/:id/:type" element={<PrivateRoute components={RemittanceDetail} accessPageId="23"  accessType = "isVisible"/>} />
            </Routes>
            }

            {
                !["/", "", "/login", "/delete/account" ,"/not-found"].includes(currentPath) && <Footer />
            }
        </>
    );
}



export default AppRouter;